import axios from "axios";

export async function fetchData<T>(url: string): Promise<T[]> {
   try {
      const response = await axios.get<T[]>(url);
      return response.data;
   } catch (error) {
      console.error("FetchData Error:", error);
      throw error;
   }
}